import * as React from 'react';
import { cn } from '../../../ui';
import { Inbox, Send, FileEdit, Archive, Trash2 } from 'lucide-react';

const ICON_MAP = { Inbox, Send, FileEdit, Archive, Trash2 };

function FolderItem({ label, iconName, unreadCount, isActive, onClick }) {
  const Icon = ICON_MAP[iconName] ?? Inbox;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex items-center gap-2 w-full px-2.5 py-1.5 rounded-md text-[12px] font-medium transition-all min-w-0',
        isActive
          ? 'bg-aqua/[0.08] text-aqua font-semibold shadow-sm border border-aqua/20'
          : 'text-text-dark-secondary hover:bg-surface-warm hover:text-text-dark border border-transparent'
      )}
    >
      <Icon size={14} className="shrink-0" />
      <span className="flex-1 min-w-0 truncate text-left">{label}</span>
      {unreadCount > 0 && (
        <span className={cn(
          'text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-none shrink-0',
          isActive ? 'bg-aqua text-nn-white' : 'bg-surface-warm text-text-muted'
        )}>
          {unreadCount}
        </span>
      )}
    </button>
  );
}

export { FolderItem };
